exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mapa {\n  height: 100vh;\n}\n#mapa .card {\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  background: #aadaff;\n}\n#mapa_resultado .modal .close {\n  top: 0px;\n  right: 0px;\n  float: none;\n  padding: 5px 9px;\n  position: absolute;\n}\n@media (min-width: 768px) {\n#mapa {\n    top: 0;\n    z-index: 1020;\n    position: -webkit-sticky;\n    position: sticky;\n    padding-top: 80px;\n    margin-top: -55px;\n}\n}", ""]);

// exports
